<template>
  <button
    @click="load()"
    class="btn"
    :class="classList"
    type="button"
    :disabled="isDisabled"
  >
    <span
      v-if="isLoading"
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
    {{ isLoading ? "Loading..." : text }}
  </button>
</template>

<script>
export default {
  name: "global button",
  data: () => ({
    isDisabled: false,
    isLoading: false,
  }),
  props: {
    classList: {
      type: String,
      default: "btn-success",
    },
    body: {
      type: Object,
      default: {},
    },
    link: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "Название кнопки text",
    },
    alert: {
      type: Boolean,
      default: false,
    },
    return: {
      type: Boolean,
      default: false,
    },
    autostart: {
      type: Boolean,
      default: false,
    },
    reload: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["return"],
  watch: {
    reload(n) {
      // Если нужно заново подгрузить данные
      if (n) this.load();
    },
  },
  methods: {
    async load() {
      if (this.link === "") return false;

      this.isDisabled = true;
      this.isLoading = true;

      let res = await this.$fetch({
        url: this.link,
        body: {
          ...this.body,
        },
        alert: this.alert,
      });

      this.isDisabled = false;
      this.isLoading = false;

      if (this.return) {
        this.$emit("return", res);
      }
    },
  },
  mounted() {
    if (this.autostart) {
      this.load();
    }
  },
};
</script>

<style>
</style>